import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./fonts/PoetsenOne-Regular.ttf";
import "./fonts/Poppins-Light.ttf";
import "./fonts/Poppins-Regular.ttf";
import "./fonts/Poppins-SemiBold.ttf";

// REACT REDUX FIREABSE
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./redux/reducers/rootReducer";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { getFirebase, ReactReduxFirebaseProvider } from "react-redux-firebase";
import firebase from "./firebase/config";
import { createFirestoreInstance } from "redux-firestore";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isLoaded, isEmpty } from "react-redux-firebase";
import { useNavigate } from "react-router-dom";
import { getPersistConfig } from "redux-deep-persist";
// import { persistor } from 'store'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// HIDE CONSOLE LOG IN PROD
// if (process.env.REACT_APP_NODE_ENV !== "DEV") console.log = () => {};

const persistConfig = getPersistConfig({
  key: "root",
  storage, // whatever storage you use
  blacklist: [
    "ciqualCategories",
    // "analysis.past",
    "analysis.future",
    "reduce.future",
    // "com.past",
    "com.future",
    // 'a3',
    // 'a4.b4.c4.no.matter.how.deep.you.go'
  ],
  rootReducer, // your root reducer must be also passed here
  // ... // any other props from original redux-persist config, omitting the stateReconciler
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk.withExtraArgument({ getFirebase })))); // un
const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunk.withExtraArgument({ getFirebase }))));
let persistor = persistStore(store);

// persistor.flush();
// persistor.purge();

const rrfProps = {
  firebase,
  config: {},
  // dispatch: store.dispatch, // un
  dispatch: persistor.dispatch,
  createFirestoreInstance,
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      {/* <BrowserRouter> */}
      {/* <Switch> */}
      {/* <AuthIsLoaded> */}
      <App />
      {/* </AuthIsLoaded> */}
      {/* </Switch> */}
      {/* </BrowserRouter> */}
    </ReactReduxFirebaseProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
